import React from "react";
import { guarantee } from "../data/content";
import { surface } from "../data/theme";
import { Reveal } from "./Reveal";
import { Section } from "./Section";
import { SectionTitle } from "./SectionTitle";
export function Guarantee() {
  return <Section labelledBy="guarantee-title" className="bg-white text-center" waveTo={surface.mist} data-id="element-94" data-mp="222n2paxov5ul">
      <Reveal data-id="element-95" data-mp="1x54q9akgq8hu">
        <div className="bg-gold-gradient relative mx-auto flex h-32 w-32 items-center justify-center rounded-full shadow-[0_16px_36px_-12px_rgba(217,154,43,0.65)]" data-id="element-96" data-mp="1x28vfv3wvzxm">
          <div aria-hidden="true" className="absolute inset-2 rounded-full border-2 border-dashed border-navy/25" data-id="element-97" data-mp="14gz36h5xs7eu" />
          <div className="text-navy" aria-hidden="true" data-id="element-98" data-mp="1j5v9o9schcdc">
            <span className="block font-display text-5xl font-extrabold leading-none" data-id="element-99" data-mp="1edkaj95fhulu">
              {guarantee.sealNumber}
            </span>
            <span className="mt-1 block text-xs font-extrabold tracking-[0.25em]" data-id="element-100" data-mp="qmext2usbifr">
              {guarantee.sealLabel}
            </span>
          </div>
        </div>
        <SectionTitle id="guarantee-title" title={guarantee.title} highlight={guarantee.highlight} className="mt-8" data-id="element-101" data-mp="oygmyiq27kce" />
        <p className="mt-3 text-sm font-extrabold uppercase tracking-[0.08em] text-gold-ink" data-id="element-102" data-mp="tx1n6i5ba40u">
          {guarantee.subtitle}
        </p>
        <p className="mx-auto mt-4 max-w-xl leading-relaxed text-navy/80 sm:text-[17px]" data-id="element-103" data-mp="yrp51y5t806g">
          {guarantee.text}
        </p>
      </Reveal>
    </Section>;
}